<script>
import Widget from '../../mixins/widget';
import { BDropdown, BDropdownItem } from 'bootstrap-vue';

export default {
  props: ['user_id'],

  mixins: [Widget],

  components: {
    BDropdown,
    BDropdownItem,
  },

  data () {
    return {
      name: 'pipeline',
      loading: true,
      error: false,
      data: {},
      stages: [],
      pipe: null,
    };
  },

  watch: {
    loading () {
      this.setPipeline(this.data.pipelines[0]);
    },
  },

  methods: {
    setPipeline (pipeline) {
      this.pipe = pipeline;
      this.stages = pipeline.stages;
    },

    getStageStyle (index) {
      return {
        height: index > 4 ? '64px' : 'auto',
      };
    },
  },
};
</script>

<template>
  <div
    class="card with-shadow"
  >
    <div
      class="card-header"
    >
      <div
        class="dropdown float-left"
      >
        <BDropdown
          no-caret
          v-if="pipe"
          variant="link"
          class="nav-action nav-profile"
          toggle-class="text-decoration-none p-0"
        >
          <template #button-content>
            <a
              href="#"
              v-if="pipe"
            >
              {{ __('Funil de') }}

              <b
                v-text="pipe.name"
              />

              <i
                class="fa fa-angle-down ml-2"
              />
            </a>
          </template>

          <template
            v-if="pipe && data.pipelines.length"
          >
            <BDropdownItem
              href="#"
              :key="pipeline.id"
              v-for="pipeline in data.pipelines"
              @click.prevent="setPipeline(pipeline)"
              :class="{ active: pipeline.id === pipe.id }"
            >
              {{ __(pipeline.name) }}
            </BDropdownItem>
          </template>
        </BDropdown>
      </div>

      <i
        v-if="loading"
        class="fa fa-circle-o-notch fa-spin float-right"
      />
    </div>

    <div
      v-show="! loading"
      class="card-body card-table"
    >
      <div
        class="table-responsive"
      >
        <table
          class="table table-borderless"
        >
          <tbody>
            <tr>
              <td
                class="text-align"
                v-for="(stage, index) in stages"
                :key="index"
              >
                <div class="content">
                  <div
                    class="stage"
                    :style="getStageStyle(index)"
                  >
                    <div class="block name">
                      {{ __(stage.name) | truncate(18) }}
                    </div>
                    <div class="block value">
                      <span>{{ __('R$') }}</span>
                      {{ stage.total | number(0) | truncate(16) }}
                    </div>
                    <div class="block count">
                      {{ stage.count }} {{ __('negócios') }}
                    </div>
                    <div class="ticket">
                      <div class="block ticket-text">
                        {{ __('Ticket Médio') }}
                      </div>
                      <div class="block value small">
                        <span class="small">{{ __('R$') }}</span>
                        {{ stage.total / stage.count | number(0) | truncate(16) }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
  @import '../../../sass/variables'

  $funnel-color: $white-gray-2
  // $funnel-color: #f9f9f9

  .card
    min-height: 365px
    background-color: $salesflow-bg-content !important

    .dropdown-toggle
      a
        color: $salesflow-font-dark

    .card-header
      // a[data-toggle="dropdown"]
      //   font-weight: 400
      //   font-size: 1.125rem

      .dropdown-menu.show
        transform: translate3d(5px, 35px, 0px) !important
        z-index: 999999
        border-radius: 0px 0px 22px 22px
        // border: 1px solid #eae6f1
        // border-top: 0
        border: 0
        // box-shadow: 0 5px 20px rgba(103, 70, 162, 0.18)

        .dropdown-item
          padding: 12px
          line-height: 16px

          &.active,
          &:active
            color: $black
            background-color: $salesflow-bg-content

    .card-body
      padding: 10px 16px 16px

      .table-responsive
        padding: 12px 0px

        &::-webkit-scrollbar
          height: 8px

        &::-webkit-scrollbar-track
          background-color: transparent

        &::-webkit-scrollbar-thumb
          background-color: $salesflow-primary
          border-radius: 8px

      .table
        margin: auto
        width: auto

        td
          padding: 0
          margin-bottom: 20px
          min-width: 150px
          height: 255px
          position: relative
          background-color: $salesflow-bg-content !important

          &:not(:last-child)
            border-right: 1px solid $salesflow-outline-gray-medium

          .content
            position: relative
            padding: 15px
            z-index: 99999

            .stage
              display: absolute
              margin-top: 43px
              text-align: center
              margin-bottom: -43px
              background-color: $salesflow-purple-extra-light

            .block
              background-color: $salesflow-purple-extra-light
              color: $salesflow-font-dark
              display: block
              z-index: 999
              font-size: 0.625rem

              &.name
                font-size: 0.75rem
                line-height: 125%
                text-transform: uppercase
                font-weight: bold

              &.value
                font-size: 1.1875rem
                font-weight: 300
                line-height: 1.21rem

                span
                  font-size: 0.875rem

              &.count
                font-size: 0.75rem
                line-height: 125%
                font-weight: 500

            .ticket
              background: $salesflow-bg-content
              position: absolute
              top: 200px
              width: 85%

              .block
                background: $salesflow-bg-content

              .ticket-text
                font-size: 0.75rem
                font-weight: 300
                line-height: 125%

              .value.small
                font-size: 0.875rem
                font-weight: 500
                line-height: 1rem

          &:before
            z-index: 9
            position: absolute
            content: ''
            top: 50px
            left: 0
            width: 0
            height: 0
            border-top: 25px solid $salesflow-purple-extra-light
            border-left: 161px solid $salesflow-purple-extra-light
            border-bottom: 30px solid $salesflow-purple-extra-light

          &:after
            content: ''
            position: absolute
            left: 0
            width: 0
            height: 0
            border-top: 25px solid $salesflow-purple-extra-light
            border-left: 161px solid $salesflow-purple-extra-light
            border-top: 30px solid $salesflow-purple-extra-light

          &:nth-child(1)
            &:before
              top: 0
              border-bottom-width: 80px
              border-top: 10px solid transparent

            &:after
              border-top-width: 80px
              border-bottom: 10px solid transparent

          &:nth-child(2)
            &:before
              top: 10px
              border-bottom-width: 70px
              border-top: 10px solid transparent

            &:after
              border-top-width: 70px
              border-bottom: 10px solid transparent

          &:nth-child(3)
            &:before
              top: 20px
              border-bottom-width: 60px
              border-top: 10px solid transparent

            &:after
              border-top-width: 60px
              border-bottom: 10px solid transparent

          &:nth-child(4)
            &:before
              top: 30px
              border-bottom-width: 50px
              border-top: 10px solid transparent

            &:after
              border-top-width: 50px
              border-bottom: 10px solid transparent

          &:nth-child(5)
            &:before
              top: 40px
              border-bottom-width: 40px
              border-top: 10px solid transparent

            &:after
              border-top-width: 40px
              border-bottom: 10px solid transparent
</style>
